export const isIncludedInQuestionTable = (
  question: { show_question?: boolean },
  showHiddenQuestions: boolean,
): boolean =>
  question.show_question === true || (showHiddenQuestions && question.show_question === false);

export const hiddenQuestionMark = (showQuestion: boolean | undefined): string =>
  showQuestion === false ? 'V' : '';

export const formatMultipleSelectLabel = (question: {
  multiple_select?: boolean;
  min_value?: number;
  max_value?: number;
}): string => {
  if (question.multiple_select !== true) {
    return '';
  }

  const hasMin = question.min_value != null;
  const hasMax = question.max_value != null;

  if ((!hasMin && !hasMax) || (hasMin && !hasMax && question.min_value === 0)) {
    return 'V';
  }
  if (hasMin && hasMax) {
    return `${question.min_value}-${question.max_value}`;
  }
  if (hasMin) {
    return `מינ ${question.min_value}`;
  }
  return `מקס ${question.max_value}`;
};
